module.exports = __webpack_public_path__ + "static/media/yingyon2.1.bde7d85a.jpg";